let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5yE6E")).then(() => parcelRequire('h9o9V'));